import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/deal-4-u/deals.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/app/components/slideshow/slideshow.jsx");
